import PropTypes from 'prop-types'
import Modal from '../../common/Modal'
import classNames from 'classnames'
import classes from './CalendarSyncModal.module.scss'
import { ReactComponent as CopyIcon } from '../../../assets/images/common/icons/copy-icon.svg'
import { toast } from 'react-toastify'
import { useEffect, useState } from 'react'
import { requestCalendarToken } from '../../../actions/userActions'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Loader from '../../common/loader/Loader'
import { getDeviceTimezone } from '../../../utility/datesHelper'

const CalendarSyncModal = ({ isOpen, onClose, scope }) => {
  const { t } = useTranslation()
  const [uuid, setUuid] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const currentUser = useSelector(state => state.user.current_user)

  useEffect(() => {
    requestCalendarToken().then((response) => {
      if (response.status === 200) {
        setUuid(response.data.calendar_uuid)
      }
      setIsLoading(false)
    })
  }, [])

  const apiBase =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_TUNNEL_URL
    : process.env.REACT_APP_API_URL

  const baseUrl = `${apiBase}/api/v1/users/${uuid}/calendar_subscriptions`
  const timezone = getDeviceTimezone()

  const communityUrl =
    scope === 'family'
      ? `${baseUrl}?scope=family&timezone=${timezone}`
      : `${baseUrl}?scope=community&timezone=${timezone}`

  const personalUrl = `${baseUrl}?scope=user&timezone=${timezone}`

  const handleCopy = (url, type) => {
    navigator.clipboard.writeText(url)
    const copyMessages = {
      family: t('dashboard.coach.calendarSyncModal.copiedFamily'),
      community: t('dashboard.coach.calendarSyncModal.copiedCommunity'),
      personal: t('dashboard.coach.calendarSyncModal.copiedPersonal'),
    }
    toast.success(copyMessages[type])
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} className={classNames(classes.modal)}>
      <h1 className={classes.title}>{t('dashboard.coach.calendarSyncModal.title')}</h1>

      {isLoading
        ? (
          <Loader>{t('common.loading')}</Loader>
        )
        : (
          <div className={classes.bodyContainer}>
            <p className={classes.description}>
              {scope === 'family'
                ? t('dashboard.coach.calendarSyncModal.descriptionFamily')
                : t('dashboard.coach.calendarSyncModal.descriptionCommunity')}
            </p>

            {!(scope === 'family' && !currentUser.family_admin) && (
              <>
                <div className={classes.label}>{scope === 'family'
                  ? t('dashboard.coach.calendarSyncModal.familyCalendarUrl')
                  : t('dashboard.coach.calendarSyncModal.communityCalendarUrl')}</div>
                <div className={classes.inputWrapper}>
                  <input type='text' readOnly value={communityUrl} />
                  <button
                    onClick={() => handleCopy(communityUrl, scope === 'family' ? 'family' : 'community')}
                    className={classes.copyButton}
                    aria-label={t('dashboard.coach.calendarSyncModal.copyCalendarLink')}
                  >
                    <CopyIcon className={classes.copyIcon} />
                  </button>
                </div>
              </>
            )}

            {!(scope === 'family' && currentUser.family_admin) && (
              <>
                <div className={classes.label}>{t('dashboard.coach.calendarSyncModal.personalCalendarUrl')}</div>
                <div className={classes.inputWrapper}>
                  <input type='text' readOnly value={personalUrl} />
                  <button
                    onClick={() => handleCopy(personalUrl, 'personal')}
                    className={classes.copyButton}
                    aria-label={t('dashboard.coach.calendarSyncModal.copyPersonalCalendarLink')}
                  >
                    <CopyIcon className={classes.copyIcon} />
                  </button>
                </div>
              </>
            )}
          </div>
        )
      }

      <div className={classes.footerContainer}>
        <button className={classes.gotItButton} onClick={onClose}>
          {t('dashboard.coach.calendarSyncModal.gotIt')}
        </button>
      </div>
    </Modal>
  )
}



CalendarSyncModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  scope: PropTypes.string.isRequired,
}

export default CalendarSyncModal
